import { render } from "./App.vue?vue&type=template&id=5563bcb6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5563bcb6&lang=less"

import exportComponent from "F:\\项目\\西湖百利佳党建\\git\\bailijia-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__